/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EventLogMetadataDto,
    EventLogMetadataDtoFromJSON,
    EventLogMetadataDtoFromJSONTyped,
    EventLogMetadataDtoToJSON,
} from './EventLogMetadataDto';

/**
 * 
 * @export
 * @interface EventLogDto
 */
export interface EventLogDto {
    /**
     * 
     * @type {EventLogMetadataDto}
     * @memberof EventLogDto
     */
    metaData?: EventLogMetadataDto;
    /**
     * 
     * @type {string}
     * @memberof EventLogDto
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof EventLogDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof EventLogDto
     */
    namespace: string;
    /**
     * 
     * @type {string}
     * @memberof EventLogDto
     */
    key: string;
}

export function EventLogDtoFromJSON(json: any): EventLogDto {
    return EventLogDtoFromJSONTyped(json, false);
}

export function EventLogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventLogDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'metaData': !exists(json, 'metaData') ? undefined : EventLogMetadataDtoFromJSON(json['metaData']),
        'id': json['id'],
        'date': (new Date(json['date'])),
        'namespace': json['namespace'],
        'key': json['key'],
    };
}

export function EventLogDtoToJSON(value?: EventLogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'metaData': EventLogMetadataDtoToJSON(value.metaData),
        'id': value.id,
        'date': (value.date.toISOString()),
        'namespace': value.namespace,
        'key': value.key,
    };
}

